module.exports = __webpack_public_path__ + "static/media/hac-sam-cu-kho-thai-lat.98c2f05f.jpg";